import { IRootState } from "../../store";

export const selectAppLoading = (state: IRootState) => state.app.isLoading;
export const selectPrevPathname = (state: IRootState) => state.app.prevPathname;
